import React, { useEffect, useState } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';

const API = axios.create({ baseURL: process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:3001/api' });

export default function DeletedProducts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    API.get('/products/deleted/list').then(r => { setProducts(r.data); setLoading(false); }).catch(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const restore = async (id) => {
    if (!window.confirm('Restore this product?')) return;
    try {
      await API.put(`/products/${id}/restore`);
      toast.success('Product restored');
      load();
    } catch { toast.error('Failed to restore'); }
  };

  return (
    <div>
      <div className="page-header">
        <div>
          <div className="page-title">Deleted Products</div>
          <div className="page-subtitle">{products.length} deleted products — restore anytime</div>
        </div>
      </div>

      <div className="card">
        {loading ? (
          <div style={{ padding: 24, color: 'var(--text-muted)' }}>Loading...</div>
        ) : products.length === 0 ? (
          <div className="empty-state"><div className="empty-state-icon">🗑</div><p>No deleted products.</p></div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead>
                <tr><th>Code</th><th>Name</th><th>Project</th><th>Department</th><th>Type</th><th style={{textAlign:'center'}}>SFG?</th><th style={{textAlign:'center'}}>Action</th></tr>
              </thead>
              <tbody>
                {products.map(p => (
                  <tr key={p.id}>
                    <td className="mono" style={{ color: 'var(--accent)', fontSize: 11, fontWeight: 600 }}>{p.product_code}</td>
                    <td style={{ fontWeight: 500 }}>{p.name}</td>
                    <td className="text-muted">{p.project_name || '—'}</td>
                    <td className="text-muted">{p.department || '—'}</td>
                    <td className="text-muted">{p.product_type || '—'}</td>
                    <td style={{ textAlign: 'center' }}>{p.is_sfg ? 'SFG' : 'FG'}</td>
                    <td style={{ textAlign: 'center' }}>
                      <button className="btn btn-primary btn-sm" onClick={() => restore(p.id)}>↩ Restore</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
